import { createContext, Context } from 'react';

const ToshibaContext: Context<any> = createContext(null);

export { ToshibaContext };
